<!--
 * @Author: v_aydwang
 * @Date: 2022-12-21 16:21:12
 * @LastEditors: v_aydwang
 * @LastEditTime: 2023-01-11 10:15:25
 * @Description: 大屏-人员基础信息
-->
<template>
  <div id="information">
    <div class="part-box">
      <div class="statistical_cycle">
        统计周期
        <el-date-picker
          v-model="datePicker"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="datePickerChange"
          @focus="onfocus"
          class="datePicker"
          :clearable="false"
          popper-class="elDatePicker"
        >
        </el-date-picker>
      </div>
      <div class="personnel_info">
        <div class="left_triangle">
          <p class="number">{{ userInfo.vendor || "-" }}</p>
          <p class="describe">供应商</p>
        </div>
        <div class="left_triangle">
          <p class="number">{{ userInfo.age || "-" }} <span>岁</span></p>
          <p class="describe">年龄</p>
        </div>
        <div class="left_triangle">
          <p class="number">
            {{ userInfo.working_time || "-" }}<span>年</span>
          </p>
          <p class="describe">在职时长</p>
        </div>
        <div class="avatar-info">
          <div class="avatar" @click="avatarClick">
            <img :src="avatarUrl" alt="" />
          </div>
          <p class="nickname" @click="onNameClick">
            {{ userInfo.nickname || "-" }}
            <Icon :component="Shuangjiantou" class="icon" />
          </p>
          <div class="active">
            <div
              style="margin-right:8px"
              :style="backColor[userInfo.job_status]"
            >
              {{ userInfo.job_status || "-" }}
            </div>
            <div
              :style="
                userInfo.job_status != '离职'
                  ? backColor[userInfo.employee_type]
                  : 'color: #A0AABD;border: 1px solid #A0AABD'
              "
            >
              {{ userInfo.employee_type || "-" }}
            </div>
          </div>
          <p class="product-con">{{ userInfo.project_name || "-" }}</p>
        </div>
        <div class="right_triangle">
          <p class="number">{{ attendanceInfo.attendance_count || 0 }}</p>
          <p class="describe">出勤天数</p>
        </div>
        <div class="right_triangle attendance">
          <p class="number">{{ attendanceInfo.attendance_rate || 0 }}%</p>
          <p class="describe">出勤率</p>
        </div>
        <div class="right_triangle">
          <p class="number">
            {{ attendanceInfo.attendance_error_count || 0 }}
          </p>
          <p class="describe">异常天数</p>
        </div>
      </div>
      <div class="product">
        <a-select class="productDrop" @change="productChange" v-model="product">
          <a-select-option v-for="item in weekList" :key="item.code">
            {{ item.name }}</a-select-option
          >
        </a-select>
      </div>
    </div>
    <a-modal
      :visible="visible"
      :footer="null"
      :closable="false"
      dialogClass="personnel-modal"
      :mask="false"
      @cancel="modalCancel"
    >
      <a-form>
        <a-row>
          <a-col class="acol" :span="24">
            <a-form-item
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              label="供应商"
            >
              <a-select v-model="form.outsourcer" @change="outsourcerChange">
                <a-select-option v-for="item in outsourcerList" :key="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col class="acol" :span="24">
            <a-form-item
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              label="作业员"
            >
              <a-select
                v-model="form.operator"
                :showSearch="true"
                allowClear
                :filter-option="filterOption"
                @change="operatorChange"
              >
                <a-select-option v-for="item in operatorList" :key="item.u_id">
                  {{ item.nickname }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item :label-col="{ span: 4 }" style="text-align:right">
              <a-button @click="reset" class="reset">重置</a-button>
              <a-button
                type="primary"
                @click="query"
                :class="{ query: true, disQuery: disabled ? true : false }"
                :disabled="disabled"
                >查询</a-button
              >
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <infoModal :checkVisible="checkVisible" :baseArchives="baseArchives">
      <template v-slot:close>
        <div @click="closeModal" class="close-x"></div>
      </template>
    </infoModal>
  </div>
</template>

<script>
import infoModal from './infoModal.vue';
import Icon from 'ant-design-vue/es/icon';
import { bus } from '../../personnel-portrait/personnel-portrait-overview/overviewConfig';
import Shuangjiantou from '../../../assets/personnel-large/shuangjiantou.svg';
import {
  getUid,
  getSupplier,
  getProductLine,
  getDetail,
  getAttendance,
  getBaseArchives,
} from '@/api/personnelLarge.js';
import moment from 'moment';
import FileShelf from '@tencent/shelf_js';
const shelf = new FileShelf({
  appId: 'v8qkjRlVS',
  appKey: 'b90ec7d9-9796-43ff-90ad-d60fc745da00',
});
export default {
  name: '',
  components: {
    infoModal,
    Icon,
  },
  data() {
    // 这里存放数据
    return {
      Shuangjiantou,
      userInfo: {
        i: 'N',
        ii: '供应商',
        id: '在职',
        id1: '制作',
        pro: '高精度地图-娄山关-母库清洗2D',
      },
      attendanceInfo: {},
      avatarUrl: require('@/assets/personnel-large/defaultAvatar.png'),
      weekList: [
        { code: 1, name: 'UC3车道数挖掘清洗 - 制作' },
        { code: 2, name: 'UC2车道数挖掘清洗 - 制作' },
        { code: 3, name: 'UC13车道数挖掘清洗 - 制作' },
        { code: 4, name: 'UC8车道数挖掘清洗 - 制作' },
      ],
      backColor: {
        在职: 'color: #165BEC;border: 1px solid #165BEC',
        制作: 'color: #00BF68;border: 1px solid #00BF68',
        验收: 'color: #00BF68;border: 1px solid #00BF68',
        内检: 'color: #00BF68;border: 1px solid #00BF68',
        管理: 'color: #00BF68;border: 1px solid #00BF68',
        离职: 'color: #A0AABD;border: 1px solid #A0AABD',
      },
      visible: false,
      checkVisible: false,
      form: {
        outsourcer: '',
        operator: '',
      },
      outsourcerList: [],
      operatorList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '近7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '近一月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '近三月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      datePicker: [
        moment()
          .subtract(7, 'days')
          .startOf('day')
          .valueOf(),
        moment()
          .subtract(1, 'days')
          .startOf('day')
          .valueOf(),
      ],
      product: '',
      disabled: false,
      baseArchives: {},
      queryTab: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 天枢大屏人员跳转判断
      this.queryTab = this.$route.query;
      this.outsourcerList = [];
      this.form.outsourcer = '';
      if (!this.queryTab.code) {
        getSupplier().then((res) => {
          this.outsourcerList = res;
          this.form.outsourcer = this.outsourcerList[0];
          this.getUid(true, true);
        });
      } else {
        getSupplier().then((res) => {
          this.outsourcerList = res;
          if (!res.includes(this.queryTab.code)) {
            this.form.outsourcer = this.outsourcerList[0];
            this.getUid(true, true);
          } else {
            this.form.outsourcer = this.queryTab.code;
            this.getUid(true, false);
          }
        });
      };
    },
    async getUid(code, flag) {
      this.form.operator = '';
      this.operatorList = [];
      if (!this.queryTab.code || flag) {
        await getUid({
          outsourcer: this.form.outsourcer,
        }).then((res) => {
          this.operatorList = res;
          this.form.operator = this.operatorList[0].u_id;
          this.getProductLine(code, true);
        });
      } else {
        await getUid({
          outsourcer: this.queryTab.code,
        }).then((res) => {
          this.operatorList = res;
          this.form.operator = this.queryTab.uid;
          this.getProductLine(code, true);
        });
      };
    },
    getProductLine(code, val) {
      this.product = '';
      this.weekList = [];
      this.disabled = true;
      getProductLine({
        uid: this.form.operator,
        start_time: this.datePicker[0],
        end_time: this.datePicker[1],
      }).then((res) => {
        this.disabled = false;
        this.weekList = res;
        if (this.weekList.length > 0) {
          this.product = this.weekList[0].code;
        }
        if (code) {
          if (val) {
            this.getUserInfo();
          }
          this.getParams(val);
        }
      });
    },
    /**
     * @description: 获取人员基础信息
     * @param {*}
     * @return {*}
     */
    getUserInfo() {
      this.userInfo = {};
      this.attendanceInfo = {};
      getDetail({
        uid: this.form.operator,
      }).then((res) => {
        this.userInfo = { ...res };
        shelf
          .pickup({
            // 调取图片信息
            code: res.photo,
            sign: true,
          })
          .then((result) => {
            this.avatarUrl = result.shelf[0].url
              ?  result.shelf[0].url
              : require('@/assets/personnel-large/defaultAvatar.png');
          })
          .catch(() => {});
        if (
          parseInt(this.userInfo.working_time / 12)
          === parseFloat(this.userInfo.working_time / 12)
        ) {
          return this.userInfo.working_time / 12;
        }
        this.userInfo.working_time = (this.userInfo.working_time / 12).toFixed(1);
        bus.$emit('projectInfo', {
          employee_type: res.employee_type,
          project_name: res.project_name,
        });
      });
      getAttendance({
        uid: this.form.operator,
        start_time: this.datePicker[0],
        end_time: this.datePicker[1],
      }).then((res) => {
        this.attendanceInfo = {
          ...res,
          attendance_rate:
            parseInt(res.attendance_rate * 100)
            === parseFloat(res.attendance_rate * 100)
              ? res.attendance_rate * 100
              : (res.attendance_rate * 100).toFixed(2),
        };
      });
      this.baseArchives = {};
      getBaseArchives({
        uid: this.form.operator,
      }).then((res) => {
        if (res) {
          this.baseArchives = {
            ...res,
            working_time:
              res.working_time
              && parseInt(res.working_time) === parseFloat(res.working_time)
                ? res.working_time
                : res.working_time.toFixed(1),
          };
        }
      });
    },
    /**
     * @description: 供应商改变
     * @param {*}
     * @return {*}
     */
    outsourcerChange() {
      this.getUid(false, true);
    },
    /**
     * @description: 作业员改变
     * @param {*}
     * @return {*}
     */
    operatorChange() {
      this.getProductLine(false, false);
    },
    getParams(code) {
      return this.$emit('cardAssembly', {
        uid: this.form.operator,
        start_time: this.datePicker[0],
        end_time: this.datePicker[1],
        production_line_code: this.product,
        code,
      });
    },
    /**
     * @description: 统计周期改变
     * @param {*}
     * @return {*}
     */
    datePickerChange() {
      this.datePicker = [
        this.datePicker[0].valueOf(),
        this.datePicker[1].valueOf(),
      ];
      this.attendanceInfo = {};
      this.getProductLine(true, false);
      getAttendance({
        uid: this.form.operator,
        start_time: this.datePicker[0],
        end_time: this.datePicker[1],
      }).then((res) => {
        this.attendanceInfo = {
          ...res,
          attendance_rate:
            parseInt(res.attendance_rate * 100)
            === parseFloat(res.attendance_rate * 100)
              ? res.attendance_rate * 100
              : (res.attendance_rate * 100).toFixed(2),
        };
      });
    },
    onfocus() {
      const len = document.getElementsByClassName('elDatePicker');
      const len1 = document.getElementsByClassName('el-picker-panel__sidebar');
      const len2 = document.getElementsByClassName('el-picker-panel__body');
      const len3 = document.getElementsByClassName('el-picker-panel__content');
      Object.values(len).map((item) => {
        item.style.maxWidth = this.setSize(720);
        item.style.marginLeft = this.setSize(30);
      });
      Object.values(len1).map((item) => {
        item.style.width = this.setSize(80);
      });
      Object.values(len2).map((item) => {
        item.style.marginLeft = this.setSize(80);
      });
      Object.values(len3).map((item) => {
        item.style.maxWidth = this.setSize(320);
      });
    },
    setSize(x) {
      const vwx = `${(x / 1920) * 100}vw`;
      return vwx;
    },
    /**
     * @description: 产线改变
     * @param {*}
     * @return {*}
     */
    productChange() {
      this.getParams(false);
    },
    /**
     * @description: 点击名字交换icon
     * @param {*}
     * @return {*}
     */
    onNameClick() {
      this.visible = true;
    },
    /**
     * @description: 点击头像
     * @param {*}
     * @return {*}
     */
    avatarClick() {
      this.checkVisible = true;
      this.visible = false;
    },
    query() {
      this.visible = false;
      this.getUserInfo();
      this.getParams(true);
    },
    reset() {
      this.form.outsourcer = this.outsourcerList[0];
      this.getUid(false, true);
    },
    closeModal() {
      this.checkVisible = false;
    },
    /**
     * @description: select 作业员下拉 筛选
     * @param {*} input
     * @param {*} option
     * @return {*}
     */
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    modalCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/convert-viewport";
@import "@/styles/basicInformation";

#information {
  height: vh(304);
  padding: 0 vw(35);
  .part-box {
    .statistical_cycle {
      font-size: vw(14);
      line-height: vh(28);
      width: 25%;
      text-align: left;
      .datePicker {
        width: vw(284);
        padding: 3px 0 3px 10px;
      }
    }
    .personnel_info {
      margin-top: vw(23);
      width: 50%;
      position: relative;
      .left_triangle,
      .right_triangle {
        padding-top: vh(15);
        width: vw(135);
        height: vh(86);
        .number {
          font-size: vw(24);
          line-height: vh(28);
          font-family: TCloudNumber-Regular;
          span {
            font-family: PingFangSC;
            font-size: vw(14);
          }
        }
        .describe {
          font-size: vw(14);
          line-height: vh(22);
        }
      }
      .left_triangle {
        padding-right: vw(20);
      }
      .right_triangle {
        padding-left: vw(20);
      }
      .attendance {
        padding-left: vw(40);
      }
      .avatar-info {
        width: vw(210);
        margin-top: vw(-8);
      }
      .avatar {
        width: vw(104);
        height: vw(104);
        &:hover{
          box-shadow: 0 6px 12px 0 rgba(192,220,255);
          border: 1px solid rgba(22, 91, 236, 0.35);
        }
      }
      .nickname {
        font-size: vw(24);
        line-height: vh(28);
        margin-bottom: vh(15);
        cursor: pointer;
        .icon {
          font-size: vw(16);
          vertical-align: baseline;
        }
      }
      .active {
        margin-bottom: vh(6);
        div {
          width: vw(48);
          height: vh(24);
          font-size: vw(12);
          line-height: vh(24);
        }
      }
      .product-con {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        font-size: vw(14);
      }
    }
    .product {
      font-size: vw(14);
      width: 25%;
      position: relative;
    }
  }
}
.close-x {
  width: vw(32);
  height: vw(32);
  background: url("../../../assets/personnel-large/close.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: vh(8);
  right: vw(10);
  cursor: pointer;
}
.elDatePicker {
  background: #000;
}
::v-deep .personnel-modal {
  width: vw(246) !important;
  height: vh(158) !important;
  top: vh(271) !important;
  .ant-row,
  .ant-col-24 {
    height: vh(50) !important;
  }
  .ant-modal-body {
    padding: vh(8) vw(10) vh(5) vw(10) !important;
  }
  .reset,
  .query {
    border-radius: 4px;
    cursor: pointer;
    width: vw(72);
    height: vh(32);
  }
  .reset {
    border: 1px solid #dce2e8;
    background: none;
    color: #41557b;
  }
  .query {
    background: #165bec;
    border: none;
    color: #ffffff;
  }
  .disQuery {
    width: vw(72) !important;
    height: vh(32) !important;
    background: #d9d9d9;
    cursor: no-drop;
  }
  .reset {
    margin-right: vw(10);
  }
}
::v-deep.productDrop {
  position: absolute;
  right: 0;
  width: vw(308);
  .ant-select-selection--single {
    background: none !important;
    border: 1px solid #cad4e7 !important;
    border-radius: 8px;
    height: vh(40);
  }
  .ant-select-dropdown {
    background: none;
  }
  .ant-select-selection--single .ant-select-selection__rendered {
    color: #56688a;
  }
  .ant-select-selection-selected-value {
    line-height: vh(38);
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: vw(14);
  }
}
::v-deep.el-range-editor.el-input__inner {
  border: 1px solid #cad4e7;
  border-radius: 8px;
  background: none ;
  height: vh(40);
}
::v-deep.el-date-editor .el-range-separator {
  color: #56688a;
  line-height: vh(32);
  margin-right: vw(10);
  font-size: vw(14);
}
::v-deep.el-date-editor .el-range__icon {
  line-height: vh(32);
  font-size: vw(16);
}
::v-deep.ant-select-selection--single {
  height: vh(34);
}
::v-deep.el-date-editor .el-range-input {
  font-size: vw(14);
}
</style>
<style lang="less" scoped>
/deep/.ant-calendar-range {
  width: 450px;
}
/deep/ .el-date-editor .el-range-input {
  background: none;
  color: #56688a;
}
/deep/.el-date-editor .el-range__close-icon {
  display: none;
}
/deep/.ant-form-item label {
  color: #41557b;
}
/deep/.ant-form-item-label > label::after {
  color: #fff;
}
</style>
